import React, {FC, useEffect, useRef, useState} from "react";
import avatar from "../../images/vlogo.png";
import {BlogsData} from "../types";
import { postBlogLike,postBlogUnLike } from "../../service";
import useUserInfo from "../../routers/useUserInfo";
import {useModal} from "../../components/modal";
import {useHistory} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import { LoadingIcon } from "../../components/loading/icons";

const classNames = require('classnames')


export function Like(props:BlogsData) {

    const [like,setLike] = useState<boolean>(false)
    const [likesQuantity,setLikeQuantity] = useState<number>(props.likesQuantity)
    const userData = useUserInfo(false)
    const modal = useModal()
    const { push } = useHistory()
    const loading = useLoading()

    const likeHandle = () => {
        if(userData){
           if(like){
               postBlogUnLike({
                   userId:userData.id,
                   blogId:props.id
               }).then(res =>{
                   if(res.code === 1){
                       setLike(false)
                       setLikeQuantity(res.data.likesQuantity)
                   }else{
                       loading.showError(res.msg)
                   }
               })
           }else{
               postBlogLike({
                   userId:userData.id,
                   blogId:props.id
               }).then(res =>{
                   if(res.code === 1){
                       setLike(true)
                       setLikeQuantity(res.data.likesQuantity)
                   }else{
                       loading.showError(res.msg)
                   }
               })
           }
        }else {
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }
    }

    return <div className="video-like">
        <div className="avatar" style={{ backgroundImage:`url(${ avatar })` }}/>
        <div className="heart" onClick={ likeHandle }>
            <p className={classNames("iconfont",{ 'fill': like })}>&#xe86f;</p>
        </div>
        <p className="count">{ likesQuantity }</p>
    </div>
}

export const VideoTitle:FC<BlogsData> = (props) => {
    return <div className="video-title">
        <h3>{ props.title }</h3>
        <p className="type">{ props.summary }</p>
        {/*<p className="tj">管家入门课程 29元/年 GO 立刻报名！</p>*/}
    </div>
}

interface VideoItemProps extends BlogsData{
    isActive:boolean
}

const VideoBox:React.FC<{src:string,poster:string}> = (props) => {
    const [status,setStatus] = useState(true)
    const video = useRef<HTMLVideoElement>(null)
    const [loader,setLoader] = useState(true)
    const process = useRef<HTMLDivElement>(null)
    const playHandle = () => {
        setStatus(false)
    }
    const startPlay = () =>{
        if(video.current){
            // @ts-ignore
            video.current.play()

        }
    }


    useEffect(() => {
        setLoader(false)
        if(video.current){
            // @ts-ignore
            document.addEventListener("WeixinJSBridgeReady", function () {
                // @ts-ignore
                video.current.play()
            }, false);

            const timer = setInterval(() => {
                if(process.current && video.current){
                    process.current.style.transform = `scaleX(${ (video.current.currentTime / video.current.duration ) })`
                }else{
                    clearInterval(timer)
                }
            })

            return () => {
                clearInterval(timer)
            }
        }
    },[props.src])

    return <div className="videoBox">
        {
            status && <div className="v-c">
                <p className="iconfont" onClick={ startPlay }>&#xe671;</p>
            </div>
        }
        {
            (loader && !status) && <div className="la">
                <LoadingIcon/>
            </div>
        }
        <video src={props.src} ref={ video } onError={event => console.log(event)}  onCanPlay={() => setLoader(false)} poster={ props.poster } onPlay={ playHandle } playsInline loop autoPlay/>
        <div className="process">
            <div className="bar" ref={process}/>
        </div>
    </div>
}

export const VideoItem:FC<VideoItemProps> = (props) => {
    return <div className="video-item">
        <VideoTitle {...props}/>
        <Like {...props}/>
        <div className="video-cover">
            {
                props.isActive ? <VideoBox src={props.videoUrl} poster={props.coverUrl}/> :
                    <img src={ props.coverUrl } alt=""/>
            }
        </div>
    </div>
}
